export interface Locale {
  default?: boolean;
  path: string;
  locale: string;
  siteLang: string;
  ogLocale: string;
  country: string;
  storeCode: string;
  aliases?: string[];
  currency: {
    type: string;
    postfix: string;
    symbol: string;
  };
  talkable: string;
  "talkable-staging": string;
  appleAuthLocale: string;
  "newsletter-checkbox-enabled": boolean;
  shipBusinessDays: number;
  deliveryDays: number;
  deliveryEstimate: [number, number];
}

// Only one item can have the "default: true" key.
const locales: Record<string, Locale> = {
  "en-US": {
    default: true,
    path: ``,
    locale: `en-US`,
    siteLang: `en-US`,
    ogLocale: `en_US`,
    country: "US",
    storeCode: "US",
    currency: {
      type: "USD",
      postfix: "",
      symbol: "$",
    },
    talkable: "ritual",
    "talkable-staging": "ritual-staging",
    appleAuthLocale: "en_US",
    "newsletter-checkbox-enabled": true,
    shipBusinessDays: 1,
    deliveryDays: 5,
    deliveryEstimate: [5, 7],
  },
  "en-GB": {
    path: `uk`,
    locale: `en-GB`,
    siteLang: `en-GB`,
    ogLocale: `en_GB`,
    country: "UK",
    storeCode: "GB",
    aliases: ["en-UK"],
    currency: {
      type: "GBP",
      postfix: "",
      symbol: "£",
    },
    talkable: "ritual-uk",
    "talkable-staging": "ritual-uk-staging",
    appleAuthLocale: "en_GB",
    "newsletter-checkbox-enabled": false,
    shipBusinessDays: 1,
    deliveryDays: 8,
    deliveryEstimate: [7, 9],
  },
  "en-CA": {
    path: `ca`,
    locale: `en-CA`,
    siteLang: `en-CA`,
    ogLocale: `en_CA`,
    country: "CA",
    storeCode: "CA",
    aliases: ["fr-CA"],
    currency: {
      type: "CAD",
      postfix: " CAD",
      symbol: "$",
    },
    talkable: "ritual-canada",
    "talkable-staging": "ritual-canada-staging",
    appleAuthLocale: "en_US",
    "newsletter-checkbox-enabled": true,
    shipBusinessDays: 1,
    deliveryDays: 8,
    deliveryEstimate: [7, 9],
  },
};

export default locales;
